import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('tulaura_cookie_consent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('tulaura_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('tulaura_cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gray-200 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 flex items-center justify-center bg-secondary/10 rounded-lg flex-shrink-0">
              <i className="ri-cookie-line text-secondary text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900 text-sm sm:text-base mb-1">
                Nous utilisons des cookies
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
                En continuant à naviguer, vous acceptez notre utilisation des cookies. 
                <Link to="/politique-confidentialite" className="text-secondary hover:underline ml-1">
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 w-full md:w-auto">
            <button
              onClick={handleDecline}
              className="flex-1 md:flex-none px-4 sm:px-6 py-2 sm:py-2.5 border-2 border-gray-300 text-gray-700 text-xs sm:text-sm font-semibold rounded-lg hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Refuser
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 md:flex-none px-4 sm:px-6 py-2 sm:py-2.5 bg-gradient-to-r from-secondary to-primary text-white text-xs sm:text-sm font-semibold rounded-lg hover:shadow-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
